import { TrendingUp, TrendingDown } from "lucide-react";

const PRICES = [
  { code: "LME", name: "Copper", value: "9,820", unit: "USD/MT", delta: "+1.12%", up: true },
  { code: "LME", name: "Cobalt", value: "33,150", unit: "USD/MT", delta: "+0.42%", up: true },
  { code: "Spot", name: "Manganese", value: "4.85", unit: "USD/DMTU", delta: "+0.18%", up: true },
  { code: "API2", name: "Coal", value: "112.60", unit: "USD/MT", delta: "+0.24%", up: true },
];

export default function CommodityPrices() {
  return (
    <section
      className="border-y border-[var(--eel-border)] bg-[var(--eel-surface)]"
      data-testid="commodity-prices"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
        <div className="md:col-span-4">
          <p className="label-eyebrow">Markets</p>
          <h3 className="font-editorial text-3xl md:text-4xl mt-3 leading-tight">
            Real-time commodity
            <span className="font-editorial-italic copper-text"> prices</span>
          </h3>
          <p className="mt-3 text-xs text-zinc-500">
            Indicative reference prices. Delayed by ~10 minutes.
          </p>
        </div>
        <div className="md:col-span-8 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--eel-border)] border border-[var(--eel-border)]">
          {PRICES.map((p, i) => {
            const Trend = p.up ? TrendingUp : TrendingDown;
            return (
              <div
                key={i}
                data-testid={`price-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[var(--eel-bg)] p-5"
              >
                <p className="label-eyebrow text-zinc-500">
                  {p.code} · {p.name}
                </p>
                <p className="font-editorial text-3xl mt-3 text-white">
                  {p.value}
                  <span className="text-xs text-zinc-500 ml-1 font-sans">
                    {p.unit}
                  </span>
                </p>
                <p
                  className={`mt-2 text-xs flex items-center gap-1 ${
                    p.up ? "text-emerald-400" : "text-rose-400"
                  }`}
                >
                  <Trend size={12} /> {p.delta}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
